window.About = (function () {
    var dom = {};
    var selectors = {
        scrollArea: '#m-page-content-scrollbar-scrollarea',
        scrollAreaMobile: window,
        pageNavigation: '#page-navigation-about',
        pageNavigationLinks: '.page-navigation__link',
        aboutContent: '#about-content'
    };
    var pageNavigation = {};
    var pageNavigationOffsetTop = 0;

    return {
        init: function () {
            dom.scrollArea = $(selectors.scrollArea); 
            dom.pageNavigation = $(selectors.pageNavigation);
            dom.aboutContent = $(selectors.aboutContent);

            pageNavigationOffsetTop = dom.pageNavigation.position().top - (dom.scrollArea.length > 0 ? dom.scrollArea.position().top : 0);

            this.hideMassMedia();
            this.updateBlocksTopOffset();            

            if (window.location.hash) {
                hashBlock = $(window.location.hash);
                if (hashBlock.length > 0) {
                    $(selectors.scrollArea).scrollTop(hashBlock.position().top);
                }
            } else {
                this.setActiveNavigationItem(0);
            }

            this.bindUI();
        },
        bindUI: function () {
            var self = this;

            var scrollTimer;

            if (globalAppSettings.isMobileDevice) {
                currentArrea = $(selectors.scrollAreaMobile);
            } else {
                currentArrea = $(selectors.scrollArea);
            }
  
            currentArrea.on('scroll.pageAbout', function (event) {
                var scrollTop = $(this).scrollTop();

                if (scrollTimer) {
                    clearTimeout(scrollTimer);
                }
                
                scrollTimer = setTimeout(function () {                    
                    self.setActiveNavigationItem(scrollTop);
                }, 50);
            });

            $(window).on('resize.pageAbout', function () {
                self.updateBlocksTopOffset();
            });

            $(document).on('click', '[about-cooperation-item]', function () {                
                var title = $(this).find('[about-cooperation-item-title]').text();
                var descr = $(this).find('[about-cooperation-item-description-text]');

                if (descr.html()) {
                    new ModalWindow({
                        title: title,
                        content: descr.parent().html()
                    }).show();
                }
            });
        },
        unbindUI: function () {
            $(selectors.scrollArea).off('scroll.pageAbout');
            $(window).off('resize.pageAbout');
        },
        updateBlocksTopOffset: function () {
            var scrollAreaTopOffset = (dom.scrollArea.length > 0 ? dom.scrollArea.position().top : 0);

            $(selectors.pageNavigationLinks).each(function (index) {
                var id = $(this).attr('href');
                var block = $(id);

                if (block.length > 0) {
                    pageNavigation[id] = {
                        offsetTop: index === 0 ? 0 : block.position().top - scrollAreaTopOffset - 80,
                        blockHeight: block.outerHeight()
                    }
                }
            });
        },
        setActiveNavigationItem: function (scrollTop) {
            for (key in pageNavigation) {
                if (scrollTop >= pageNavigation[key].offsetTop && scrollTop < pageNavigation[key].offsetTop + pageNavigation[key].blockHeight) {
                    $(selectors.pageNavigationLinks).removeClass('m-active');
                    $(selectors.pageNavigationLinks).filter('[href="' + key + '"]').addClass('m-active');
                    
                    if (history.pushState && window.location.hash !== key) {
                        history.pushState(null, null, key);
                    }
                }
            }
        },
        hideMassMedia: function () {
            var container = $('#about-mass-media-items-container');
            var containerWrapper = $('#about-mass-media-items-container-wrapper');
            var items = $('[js-node="about-mass-media-item"]');
            var itemsCnt = items.length;
            var showMoreButton = $('#about-mass-media-show-more-button');
            var self = this;

            if (container.height() > containerWrapper.height()) {
                showMoreButton.removeClass('m-hidden');

                $(document).on('click', '#about-mass-media-show-more-button', function () {
                    containerWrapper.removeClass('m-collapsed');
                    $(this).addClass('m-hidden');
                    self.updateBlocksTopOffset();
                });
            }
        }
    }
}());

$(function () {
    if ($('[data-page="about"]').length > 0) {
        window.About.init();

        if (globalAppSettings.isMobileDevice && UpButton) {
            UpButton.init();
            if ($('#contentEl').length > 0) {
                var point = $('.about__content').offset().top;
                $(window).scrollTop(point - 50);
            }
        }
    }

});